import React from 'react';
import Icon, { type IconName } from '../../../components/AppIcon';

type ColorType = 'primary' | 'success' | 'warning' | 'error';

interface TaskStatsCardProps {
	title: string;
	value: number | string;
	icon: IconName;
	color?: ColorType;
}

const TaskStatsCard: React.FC<TaskStatsCardProps> = ({ title, value, icon, color = 'primary' }) => {
	const getColorClasses = (colorType: ColorType): string => {
		const colors: Record<ColorType, string> = {
			primary: 'bg-primary/10 text-primary',
			success: 'bg-success/10 text-success',
			warning: 'bg-warning/10 text-warning',
			error: 'bg-error/10 text-error'
		};
		return colors[colorType] || colors.primary;
	};

	return (
		<div className="bg-card border border-border rounded-lg p-4 sm:p-5 card-shadow overflow-hidden">
			<div className="flex items-center space-x-2 sm:space-x-3 gap-2">
				<div className={`p-2 sm:p-2.5 rounded-lg flex-shrink-0 ${getColorClasses(color)}`}>
					<Icon name={icon} size={18} className="sm:w-5 sm:h-5" />
				</div>
				<div className="flex-1 min-w-0">
					<h3 className="text-lg sm:text-xl font-bold text-foreground truncate">{value}</h3>
					<p className="text-xs sm:text-sm text-muted-foreground truncate">{title}</p>
				</div>
			</div>
		</div>
	);
};

export default TaskStatsCard;
